import { createAction, props } from '@ngrx/store';
import { Account } from '@qvs/core';
import { createLoadingStatusActionGroup } from '~/shared/helpers/loading-status-helper';

const prefix = '[Account]';

export const {
  load: loadAccounts,
  success: loadAccountsSuccess,
  failure: loadAccountsFailure
} = createLoadingStatusActionGroup(prefix, 'accounts');

export const upsertAccounts = createAction(`${prefix} upsert accounts`, props<{ entities: Account[] }>());
